import { useRef, useEffect } from 'react';

export function useEffectSkipFirst(fn, arr) {
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }

    fn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, arr);
}
